module.exports = __webpack_public_path__ + "img/titleEle.53dd6060.svg";